export default __webpack_public_path__ + "static/media/template-black-2040.253b340c.png";